import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { getSpotRate } from '@/app/lib/api-client'
import { reactQueryKeys } from '@/utils/constants'
import { isValidUuid } from '@/utils/helpers'

export const useRate = (uuid: string, interval?: number | false) => {
  const {
    data: rate,
    isPending,
    isError,
    isFetching,
    error,
  } = useQuery({
    queryKey: reactQueryKeys.rate(),
    queryFn: () => getSpotRate(uuid),
    enabled: isValidUuid(uuid),
    refetchInterval: interval,
    staleTime: 0,
    refetchOnWindowFocus: false,
  })

  if (isError) {
    logSentryError('Error from hook: useRate', error, {
      uuid,
    })
  }

  return {
    rate,
    isLoading: isPending,
    isError,
    isFetching,
  }
}

export default useRate
